import { render, staticRenderFns } from "./SkeletonProduct.vue?vue&type=template&id=afbf6e62&"
import script from "./SkeletonProduct.vue?vue&type=script&lang=js&"
export * from "./SkeletonProduct.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports